import { Component } from '@angular/core';
import {  NavController, NavParams, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the MasInformacionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-mas-informacion',
  templateUrl: 'mas-informacion.html',
})
export class MasInformacionPage {
  public img:string;
  public descripcion:string;
  public nombre:string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public menuCtrl:MenuController,
    public global: VariablesGlobales,) {
    this.img = this.navParams.get("img");
    this.descripcion = this.navParams.get("descripcion");
    this.nombre = this.navParams.get("nombre");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad MasInformacionPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/mas-informacion/mas-informacion.ts